const siteConfig = {
  url: "https://nexo2.netlify.com",
  title: "Roots | Nexo 2(2021)",
  shortTitle: "Roots",
  author: "Nexo Creative Writing",
  description:
    "Interpretations on belonging, migration, food cultures, and family by Nexo’s writers. Read thought-provoking texts in English, Spanish and Finnish.",
  keywords:
    "Nexo, Nexo Creative Writing, Nexo Creative Writing group, Nexo Zine, creative writing, literary magazine, roots, emigration, migrant stories, luova kirjoittaminen, tarinankerronta, Helsinki, yhteisö, writer group, community, workshop, työpaja, stories",
  image: "/png/roots.png",
  icon: "static/svg/favicon.svg",
  themeColor: "#000000",
  backgroundColor: "#ffffff",
};

module.exports = siteConfig;
